import { useEffect, useRef } from 'react';

// Tiempo oculta a partir del cual, al volver, conviene re-sincronizar. Por debajo de
// esto la conexión en vivo casi nunca se corta y re-pedir sería ruido.
export const RESYNC_AFTER_HIDDEN_MS = 60 * 1000;

// useResyncOnVisible — llama a `onResync` cuando la pestaña vuelve a estar visible
// después de haber estado oculta al menos `minHiddenMs`.
//
// Por qué: los supervisores dejan Rutas en vivo / Seguimiento en vivo de fondo largos
// ratos. Al volver, las rutas se refrescan solas (polling), pero las posiciones GPS
// solo llegan por el socket, que el navegador puede haber dormido o cortado: en Clarity
// se los veía recargar la página a mano para ver dónde estaban los repartidores.
export default function useResyncOnVisible(onResync, minHiddenMs = RESYNC_AFTER_HIDDEN_MS) {
  // Ref para no re-suscribir el listener cada vez que cambia la función del llamador.
  const callbackRef = useRef(onResync);
  useEffect(() => {
    callbackRef.current = onResync;
  }, [onResync]);

  useEffect(() => {
    let hiddenAt = document.hidden ? Date.now() : null;
    const onVisibilityChange = () => {
      if (document.hidden) {
        hiddenAt = Date.now();
        return;
      }
      const hiddenFor = hiddenAt == null ? 0 : Date.now() - hiddenAt;
      hiddenAt = null;
      if (hiddenFor >= minHiddenMs) callbackRef.current?.();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, [minHiddenMs]);
}
